export default __webpack_public_path__ + "static/media/consult.a61e80a7.jpg";